document.addEventListener('DOMContentLoaded', () => {
  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 1140,
    },
  });

  if(767 < window.innerWidth){
    $(".modal_open").colorbox({
      inline:true,
      width:"auto",
      height:"auto",
      opacity: 0.7
    });

    $('.flexslider').flexslider({
      animation: 'slide',
      slideshow: false,
      prevText: '',
      nextText: '',
      controlsConatiner: '.modal_nav',
      manualControls: ".thumb .image",
    });

    $(".modal_open").click( function() {
      var idx = $(this).data("index");
      $('.flexslider').flexslider(idx);
    });
  }else{
    UWX.MenuActivate('.btn_of', '.item_of');
    UWX.MenuActivate('.btn_gr', '.item_gr');
    UWX.MenuActivate('.btn_ki', '.item_ki');
    UWX.MenuActivate('.btn_mw', '.item_mw');
  }
});
